// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_18ZX8","separator":"index_separator_2p-dh"};